module.exports = __webpack_public_path__ + "assets/img/hng.f53de0fbc38f124b24ec8c4e02b093fb.svg";